export default {
  skippedPhotoPicker: {
    incrementAmount: 2,
    tag: "skippedPhotoPicker",
  },
};
